<template>
  <div class="flex h-screen w-full overflow-hidden bg-slate-100">
    <div class="w-full flex-1 overflow-hidden">
      <Topbar />

      <div class="mt-[64px] flex h-[calc(100vh-64px)] flex-col overflow-hidden p-4 md:p-5 lg:p-6">
        <button
          type="button"
          class="mb-3 inline-flex w-fit items-center gap-2 rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm font-medium text-slate-600 transition-colors hover:border-slate-300 hover:text-slate-900"
          @click="back"
        >
          <i class="pi pi-arrow-left" />
          Назад
        </button>

        <div class="mb-4 flex shrink-0 items-start justify-between gap-3">
          <div>
            <h2 class="text-2xl font-semibold tracking-tight text-slate-900 md:text-3xl">Поступление {{ arrivalId }}</h2>
            <p class="mt-1 text-sm text-slate-500 md:text-base">Детализация накладной по товарам, количеству и закупочной стоимости</p>
          </div>
        </div>

        <div class="min-h-0 flex-1 overflow-hidden rounded-2xl border border-slate-200 bg-white p-4 shadow-sm md:p-6">
          <div v-if="arrivals.length" class="mb-4 grid shrink-0 grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-5">
            <div class="rounded-xl border border-slate-200 bg-slate-50 px-4 py-3">
              <p class="text-xs font-medium uppercase tracking-wide text-slate-500">Дата и время</p>
              <p class="mt-1 text-sm font-medium text-slate-900">{{ arrivals[0].date }}</p>
            </div>
            <div class="rounded-xl border border-slate-200 bg-slate-50 px-4 py-3">
              <p class="text-xs font-medium uppercase tracking-wide text-slate-500">Контрагент</p>
              <p class="mt-1 text-sm font-medium text-slate-900">{{ arrivals[0].counterparty }}</p>
            </div>
            <div class="rounded-xl border border-slate-200 bg-slate-50 px-4 py-3">
              <p class="text-xs font-medium uppercase tracking-wide text-slate-500">Счет</p>
              <p class="mt-1 text-sm font-medium text-slate-900">{{ arrivals[0].account }}</p>
            </div>
            <div class="rounded-xl border border-slate-200 bg-slate-50 px-4 py-3">
              <p class="text-xs font-medium uppercase tracking-wide text-slate-500">Банк</p>
              <p class="mt-1 text-sm font-medium text-slate-900">{{ arrivals[0].bank }}</p>
            </div>
            <div class="rounded-xl border border-slate-200 bg-slate-50 px-4 py-3">
              <p class="text-xs font-medium uppercase tracking-wide text-slate-500">Валюта</p>
              <p class="mt-1 text-sm font-medium text-slate-900">{{ arrivals[0].currency }}</p>
            </div>
          </div>

          <DataTable
            :value="arrivals"
            resizableColumns
            columnResizeMode="fit"
            headerClass="!text-center"
            removableSort
            showGridlines
            stripedRows
            paginator
            size="small"
            :rows="10"
            :rowsPerPageOptions="[5, 10]"
            scrollable
            scrollHeight="flex"
            class="arrival-table h-full"
          >
            <Column field="name" sortable header="Наименование" style="min-width: 14rem"></Column>
            <Column field="barcode" sortable header="Штрихкод" style="min-width: 11rem"></Column>
            <Column field="unit" sortable header="Ед. изм." style="min-width: 8rem"></Column>
            <Column field="amount" sortable header="Количество" style="min-width: 8rem"></Column>
            <Column field="price" sortable header="Закуп. цена/ед." style="min-width: 10rem"></Column>
            <Column field="net" sortable header="Себес. итого" style="min-width: 10rem" frozen class="!text-end"></Column>
            <ColumnGroup type="footer">
              <Row>
                <Column footer="Итого:" :colspan="5" footerStyle="text-align:right" />
                <Column :footer="formattedTotal" footerStyle="text-align:right" />
              </Row>
            </ColumnGroup>
          </DataTable>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import axios from '../lib/axios'
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Row from 'primevue/row';
import ColumnGroup from 'primevue/columngroup';

const route = useRoute()
const router = useRouter()
const arrivals = ref([]);
const arrivalId = route.params.id

const getArrivals = async () => {
    const res = await axios.get('/api/arrival?arrival_id=' + arrivalId);
    arrivals.value = res.data
}

const back = () => {
    router.push({ name: 'Arrival' })
}

const formattedTotal = computed(() => {
  const sum = arrivals.value.reduce((acc, b) => acc + (Number(b.net) || 0), 0)
  return new Intl.NumberFormat('ru-RU', { style: 'decimal', minimumFractionDigits: 0 }).format(sum)
})

onMounted(() => {
    getArrivals()
})
</script>

<style scoped>
:deep(.arrival-table .p-datatable-table-container) {
  border-radius: 1rem;
  border: 1px solid rgb(226 232 240);
}

:deep(.arrival-table .p-datatable-thead > tr > th) {
  background: rgb(248 250 252);
  color: rgb(71 85 105);
  font-weight: 600;
  border-color: rgb(226 232 240);
  padding: 0.9rem 1rem;
}

:deep(.arrival-table .p-datatable-tbody > tr > td) {
  border-color: rgb(241 245 249);
  color: rgb(30 41 59);
  padding: 0.9rem 1rem;
}

:deep(.arrival-table .p-datatable-tbody > tr:hover) {
  background: rgba(240, 253, 250, 0.7);
}

:deep(.arrival-table .p-paginator) {
  border: 0;
  border-top: 1px solid rgb(226 232 240);
  background: white;
  padding-top: 0.75rem;
}

:deep(.arrival-table .p-datatable-tfoot > tr > td) {
  background: rgb(248 250 252);
  color: rgb(15 23 42);
  font-weight: 600;
  border-color: rgb(226 232 240);
}
</style>
